<template>
  <div :class="size">
    <div class="rais-box">
      <div class="rais-box-photo">
        <router-link :to="{ name: 'show_fundraising', params: { id: project.id, title: project.title.replace(/ /g, '-') } }">
          <img v-if="project.photo.thumb.url" :src="$server_url + project.photo.thumb.url">
          <img v-else src="~assets/img/projectPlaceholder.png">
        </router-link>
      </div>
      <!-- rais-box-photo-->
      <div class="rais-box-text">
        <router-link :to="{ name: 'fundraising', query: { category: project.category.name }}" class="category">
          {{ project.category.name }}
        </router-link>
        <span v-if="showStatus" class="days-left pull-right">
          {{ $t(`project.status.${project.status}`) }}
        </span>
        <br/>
        <router-link :to="{ name: 'show_fundraising', params: { id: project.id, title: project.title.replace(/ /g, '-') } }" class="title">
          {{ project.title }}
        </router-link>
        <br/>
        <router-link :to="{ name: 'show_profile', params: { id: project.user.id } }" class="author">
          {{ project.user.full_name }}
        </router-link>
        <br/>
        <p class="short-desc">{{ project.description }}</p>
        <p class="allready-raised">${{ completion * 100 }}</p>
        <div class="bar-goal">
          <div :style="{ width: completion + '%' }" class="bar-raised"></div>
        </div>
        <div class="days-left">
          <div v-if="project.deadline && project.status === 'published'">
            {{ project.deadline | daysLeft }} {{ $t('project.daysLeft') }}
          </div>
          <div v-if="project.deadline && project.status === 'successful'">{{ $t('project.ended') }}</div>
          <div v-if="!project.deadline">{{ project.duration + ' ' + $t('project.daysLeft')}}</div>
        </div>
        <div class="goal">{{ project.currency | currencySymbol }}{{ project.to_collect | price }} {{ $t('project.goal') }}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['project', 'size', 'showStatus'],
  computed: {
    completion() {
      return Math.round((this.project.collected / this.project.to_collect) * 100);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Fundraising.vue?50b7d829